import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { PageEnum } from '@/enums/pageEnum';

const championships: AppRouteModule = {
    path: '/championships',
    name: PageEnum.CHAMPIONSHIPS,
    component: LAYOUT,
    redirect: '/championships/index',
    meta: {
        orderNo: 14,
        icon: 'championships',
        title: '锦标赛',
        /** 是否有等级分限制 */
        scoreLimit: true,
        /** 赛事类型 1：锦标赛，2：战力赛 */
        type: 1,
        /** 大厅页 */
        homePageName: 'ChampionshipsIndex',
        /** 赛事详情页 */
        detailsPageName: PageEnum.COMPETITION_DETAILS,
        /** 游戏页 */
        gamePageName: PageEnum.COMPETITION_GAME,
    },
    children: [
        {
            path: 'index',
            name: 'ChampionshipsIndex',
            component: () => import('@/views/menu/championships/index.vue'),
            meta: {
                title: '公开锦标赛',
            },
        },
        {
            path: 'details',
            name: PageEnum.COMPETITION_DETAILS,
            component: () => import('@/views/menu/championships/competition-details/index.vue'),
            meta: {
                title: '锦标赛',
            },
        },
        {
            path: 'game',
            name: PageEnum.COMPETITION_GAME,
            component: () => import('@/views/menu/championships/game/index.vue'),
            meta: {
                title: '锦标赛',
            },
        },
    ],
};

export default championships;
